var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('NavHeader',{attrs:{"category":_vm.category}}),_c('router-view',{attrs:{"category":_vm.category}}),_c('NavFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }